<template>
  <v-btn
      :text="text"
      variant="outlined"
      rounded
      color="red"
      prepend-icon="fas fa-arrow-left"
      class="ml-2 mb-5"
      size="small"
      @click.prevent="$emit('clicked'); openLink(false)"
      @auxclick.prevent="$emit('clicked'); openLink(true)"
  />
</template>

<script setup>

  import {router} from "@inertiajs/vue3";

  const props = defineProps({

    /**
     * The route that the user will be redirected to when the button is pressed.
     */
    route: {
      type: String,
      required: true
    },

    /**
     * The text of the button.
     */
    text: {
      type: String,
      required: true
    },

  });

  function openLink(middleClick) {


    if (middleClick)
      window.open(props.route, '_blank');
    else
      router.get(props.route);
  }




</script>
